$(document).ready(function() {
  function getDeliveryDate() {
    // Get today's date
    var today = new Date();

    // Add 2 days to today's date
    var deliveryDate = new Date(today);
    deliveryDate.setDate(today.getDate() + 2);

    // Check if the new date falls on a weekend
    if (deliveryDate.getDay() === 6) {
      // Saturday → set to Monday
      deliveryDate.setDate(deliveryDate.getDate() + 2);
    } else if (deliveryDate.getDay() === 0) {
      // Sunday → set to Monday
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }

    // Always use English (US)
    var options = { weekday: 'short', month: 'short', day: 'numeric' };
    var formattedDate = deliveryDate.toLocaleDateString('en-US', options);

    // Inject the formatted date into the element with class 'delivery_date'
    $('.delivery_date').text(formattedDate);
  }

  // Call the function to set the delivery date
  getDeliveryDate();
});
